import './meal-deal-item-card.css';

import { IDataCoupon } from '../../../models/data.interface';
import { Util } from '../../../utils/util';
import { Order } from '../../../models/order';
import { ILoyaltyProvider } from '../../../services/loyalty-provider/loyalty-provider.interface';
import { DataLayerService } from '../../../services/data-layer-service';
import { ICheckCouponHasQualifyingItemsParams } from '@ts/models/coupons.interface';
import { Data } from '../../../models/data';
import { DataLayerPromotionLocation } from "../../../types/enums";
import { LocalizationService } from '../../../services/localization-service';

enum CouponImageType {
    NONE = -1,
    THUMBNAIL = 0,
    FULL_BOX = 1
}

export class MealDealItemCard {
    private readonly _localizationService: LocalizationService;
    private readonly _item: IDataCoupon;
    private readonly _element: HTMLElement;
    private readonly _index: number;

    constructor(data: Data, order: Order, localizationService: LocalizationService, loyaltyProvider: ILoyaltyProvider, dataLayer: DataLayerService, item: IDataCoupon, index: number) {
        this._localizationService = localizationService;
        this._item = item;
        this._index = index;
        this._element = this._createElement(data);
        this._addClickHandler(order, loyaltyProvider, dataLayer);
    }

    private _createElement(data: Data): HTMLElement {
        const name = this._localizationService.GetName(this._item.Names);
        const couponDisplay = data.getProperty("Settings").OOS.couponDisplayType ?? CouponImageType.NONE;

        let html = "";
        switch (couponDisplay) {
            case CouponImageType.NONE:
            case CouponImageType.THUMBNAIL:
                html = this._createThumbnailCard(name);
                break;
            case CouponImageType.FULL_BOX:
                html = this._createFullBoxCard(name);
                break;
        }

        return Util.createHtmlElementFromTemplate(html);
    }

    private _createThumbnailCard(name: string): string {
        const description = this._localizationService.GetDescription(this._item.Descriptions);

        // 2DO: Show Price section using coupon.CouponTypeId and coupon.Discount
        const price = ""; //<p class="meal-deal-card-price">STARTING AT $8.99</p>

        return `
            <div id="div_menu_item_hot_deal_${this._item.CouponId}" name="div_menu_item_hot_deal" class="meal-deal-card" data-cid="${this._item.CouponId}" data-index="${this._index}">
                    ${this._item?.Images?.Thumbnail ? `<div class="meal-deal-card-image">
                        <img id="img_menu_item_hot_deal_${this._item.CouponId}" src="${this._item?.Images?.Thumbnail}" alt="${name}">
                    </div>` : ""}
                    <div class="meal-deal-card-content">
                        <div>
                            <h2 class="meal-deal-card-title" ltagj="${Util.toLtagj(this._item.Names)}">${name}</h2>
                            <p class="meal-deal-card-description" ltagj="${Util.toLtagj(this._item.Descriptions)}">${description}</p>
                        </div>
                        ${price}
                    </div>
                </div>`;
    }

    // Leaving this function for future use, Setting 242 refactor incoming eventually.
    private _createFullBoxCard(name: string): string {
        return `
            <div id="div_menu_item_hot_deal_${this._item.CouponId}" name="div_menu_item_hot_deal" class="meal-deal-card" data-cid="${this._item.CouponId}" data-index="${this._index}">
                <div class="meal-deal-card-image-full">
                    <img id="img_menu_item_hot_deal_${this._item.CouponId}" src="${this._item.Images?.Full}" alt="${name}">
                </div>
            </div>`;
    }

    public get element(): HTMLElement {
        return this._element;
    }

    private _addClickHandler(order: Order, loyaltyProvider: ILoyaltyProvider, dataLayer: DataLayerService): void {
        this._element.onclick = async () => {
            if (!order.isCouponAllowedInFundraiser() || !order.isCouponAllowedInChallengeEvent())
                return;

            const params: ICheckCouponHasQualifyingItemsParams = {
                couponId: this._item.CouponId
            };
            await order.checkCouponHasQualifyingItemsAsync(loyaltyProvider, params);

            if (dataLayer)
                dataLayer.select_promotion(this._item.CouponId, this._item.Names, DataLayerPromotionLocation.MEAL_DEAL, this._index);
        };

        const image = this._element.querySelector(`img_menu_item_hot_deal_${this._item.CouponId}`) as HTMLImageElement;
        if (image) {
            image.onerror = () => { image.style.display = "none"; };
        }
    }
}